module.exports = __webpack_public_path__ + "static/media/squared_french.3dea3da1.svg";